import React, {Component} from 'react'
import {Link} from 'react-router-dom'

import Header from "../components/Header";
import Footer from '../components/Footer'

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clubs:{}
        }
    }
    componentDidMount () {
        this.fetchClubs();
    }
    fetchClubs() {
        let api = process.env.REACT_APP_API_URL + '/get-clubs';
        api += '?key=' + process.env.REACT_APP_API_KEY;
        fetch(api).then((response) => response.json()).then((responseJson) => {
            console.log(responseJson.data);
            if (!responseJson.data) {
                this.setState({});
            } else {
                this.setState({clubs: responseJson.data});
            }
        });
    }
    renderClubs(){
        if( Object.keys(this.state.clubs).length==0 ){
            return null;
        }
        let options = [];
        for(let v of this.state.clubs) {
            options.push(<li key={v.id}><Link to={'/club/'+v.id}>{v.univ_name} {v.ct_name}部</Link></li>);
        }
        return (
            <ul>
                {options}
            </ul>
        );
    }
    render() {
        return (
            <div>
                <Header/>
                <div className="content partslist-page">
                    <div className="container">
                        <div className="pb-5">
                            <h1 className="title-partslist-page">利用部活一覧</h1>
                            <div className="img-three-dot">
                                <img src="images/three-dot.png" className="img-fluid"/>
                            </div>
                            {this.renderClubs()}
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default Home